import React from 'react';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-wh-pink pt-16 pb-8" data-id="element-62">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-63">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-64">
          {/* Brand Column */}
          <div data-id="element-65">
            <img src="https://cdn.magicpatterns.com/uploads/6G36xTJ4eeBqvZ8tYXgCey/logo.webp" alt="Wear Haus Designs" className="h-12 w-auto mb-6" data-id="element-66" />
            <p className="text-white/90 mb-6" data-id="element-67">
              We Logo Your Life. Specializing in screen print, embroidery,
              direct to garment and textile laser etching.
            </p>
            <div className="flex space-x-4" data-id="element-68">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 border border-white/20 flex items-center justify-center text-white hover:bg-white hover:text-wh-pink transition-all" data-id="element-69">
                <Facebook className="w-5 h-5" data-id="element-70" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 border border-white/20 flex items-center justify-center text-white hover:bg-white hover:text-wh-pink transition-all" data-id="element-71">
                <Instagram className="w-5 h-5" data-id="element-72" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 border border-white/20 flex items-center justify-center text-white hover:bg-white hover:text-wh-pink transition-all" data-id="element-73">
                <Twitter className="w-5 h-5" data-id="element-74" />
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div data-id="element-75">
            <h3 className="text-lg font-bold text-white mb-6" data-id="element-76">Contact Us</h3>
            <ul className="space-y-4" data-id="element-77">
              <li className="flex items-start" data-id="element-78">
                <MapPin className="w-5 h-5 text-wh-yellow mt-1 mr-3 flex-shrink-0" data-id="element-79" />
                <span className="text-white/90" data-id="element-80">
                  4425 West US 20, Suite 1<br data-id="element-81" />
                  LaGrange, Indiana 46761
                </span>
              </li>
              <li className="flex items-center" data-id="element-82">
                <Phone className="w-5 h-5 text-wh-yellow mr-3 flex-shrink-0" data-id="element-83" />
                <a href="tel:260-463-7373" className="text-white/90 hover:text-white transition-colors" data-id="element-84">
                  260-463-7373
                </a>
              </li>
              <li className="flex items-center" data-id="element-85">
                <Mail className="w-5 h-5 text-wh-yellow mr-3 flex-shrink-0" data-id="element-86" />
                <a href="mailto:wearhaus@wearhaus.net" className="text-white/90 hover:text-white transition-colors" data-id="element-87">
                  wearhaus@wearhaus.net
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div data-id="element-88">
            <h3 className="text-lg font-bold text-white mb-6" data-id="element-89">
              Business Hours
            </h3>
            <ul className="space-y-4" data-id="element-90">
              <li className="flex items-start" data-id="element-91">
                <Clock className="w-5 h-5 text-wh-yellow mt-1 mr-3 flex-shrink-0" data-id="element-92" />
                <div data-id="element-93">
                  <span className="block text-white font-medium" data-id="element-94">
                    Monday – Friday
                  </span>
                  <span className="text-white/90" data-id="element-95">8:00 AM to 4:00 PM EST</span>
                </div>
              </li>
              <li className="flex items-start" data-id="element-96">
                <Clock className="w-5 h-5 text-white/30 mt-1 mr-3 flex-shrink-0" data-id="element-97" />
                <div data-id="element-98">
                  <span className="block text-white font-medium" data-id="element-99">
                    Saturday – Sunday
                  </span>
                  <span className="text-white/90" data-id="element-100">Closed</span>
                </div>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div data-id="element-101">
            <h3 className="text-lg font-bold text-white mb-6" data-id="element-102">Quick Links</h3>
            <ul className="space-y-3" data-id="element-103">
              {['Home', 'About Us', 'Services', 'Helpful Info', 'Products', 'Contact'].map(item => <li key={item} data-id="element-104">
                  <a href="#" className="text-white/90 hover:text-white transition-colors flex items-center" data-id="element-105">
                    <span className="w-1.5 h-1.5 bg-wh-yellow rounded-full mr-2" data-id="element-106"></span>
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-107">
          <p className="text-white/80 text-sm mb-4 md:mb-0" data-id="element-108">
            © {new Date().getFullYear()} Wear Haus Designs. All rights
            reserved.
          </p>
          <div className="flex space-x-6 text-sm text-white/80" data-id="element-109">
            <a href="#" className="hover:text-white transition-colors" data-id="element-110">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-111">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}